<template>
  <div>
    <Component
      :is="data.model_type === 'stub' ? 'div' : NuxtLink"
      :to="getUrl"
      :target="(isBlank || data?.outer_link) && '_blank'"
      class="group relative flex size-full text-white-100"
      :class="[
        { 'rounded-[12px]': !disablePreview },
        {
          'mb-6 rounded-none border-b border-new-card--border pb-3':
            disablePreview,
        },
      ]"
    >
      <MainPageCardsReworkedCommonCardImageBlock
        v-if="!disablePreview"
        v-bind="{
          data,
          disableLabel,
          priorityImage,
          position: positionImage,
        }"
        :priority-load="priorityLoad"
        :aspect="aspect"
        :no-overlay="disableTitle"
        :animation="animation"
        class="size-full"
      >
        <template #cover>
          <slot name="cover" />
        </template>
        <template #badge>
          <slot name="badge" />
        </template>
      </MainPageCardsReworkedCommonCardImageBlock>

      <div
        class="flex size-full flex-col justify-end font-roboto"
        :class="{ 'absolute p-[20px]': !disablePreview }"
      >
        <h2
          v-if="!disableTitle && !data?.hidden_title"
          class="text-clamp-3 z-30 font-medium"
          :class="[
            !isBookmark && titleTextSize,
            {
              'text-[20px] leading-[24px] text-new-test-black': disablePreview,
            },
            {
              'xl:text-[18px] xl:leading-[22px] 2xl:text-[18px] 2xl:leading-[22px]':
                isBookmark,
            },
            { ' mb-2.5': isMobile && isPagination },
          ]"
        >
          {{ getTitle }}
        </h2>
      </div>
    </Component>
  </div>
</template>

<script setup>
const NuxtLink = resolveComponent('NuxtLink');

const props = defineProps({
  data: { type: Object, default: () => ({}) },
  disableTitle: { type: Boolean, default: false },
  disableLabel: { type: Boolean, default: false },
  disablePreview: { type: Boolean, default: false },
  isPagination: { type: Boolean, default: false },
  isSmallTitle: { type: Boolean, default: false },
  isBookmark: { type: Boolean, default: false },
  titleLength: { type: Number, default: 0 },
  priorityImage: { type: String, default: '' },
  priorityLoad: { type: Boolean, default: false },
  positionImage: { type: String, default: 'object-[50%_25%]' },
  animation: { type: Boolean, default: true },
  isBlank: { type: Boolean, default: false },
  aspect: {
    type: Object,
    default: () => ({
      w: 16,
      h: 9,
    }),
  },
});

const { isMobile } = useBreakpoint();
const { formatWikiTitle } = useTextCase();
const getCardSettings = useCardSettings();
const getDataByModel = computed(() => getCardSettings(props.data));

const getTitle = computed(() => {
  const title = formatWikiTitle(props.data);
  if (!title || !props.titleLength) return title;

  return title.length > props.titleLength
    ? `${title.slice(0, props.titleLength)}...`
    : title;
});

const getUrl = computed(() => {
  return (
    props.data?.outer_link ??
    props.data?.url ??
    `${getDataByModel?.value?.hrefBase}${props.data?.slug ?? props.data?.id}`
  );
});

const titleTextSize = computed(() => {
  if (props.isSmallTitle) {
    return 'text-[14px] leading-[18px] 2xl:text-[18px] 2xl:leading-[23px]';
  }
  if (props.disablePreview) {
    return 'text-new-test-black text-[20px] leading-[24px]';
  }
  return 'text-[18px] leading-[22px] 2xl:text-[22px] 2xl:leading-[28px] font-semibold';
});
</script>
